<template>
  <div class="orders orders--single">
    <div class="close-cross" @click="cancelOrder"></div>
    <h1 v-html="texts.orderCard.title"></h1>
    <div class="orders__left-block">
      <div class="product">
        <div
          class="product__image"
          :style="[prod.img ? { 'background-image': 'url(' + require('@/assets/' + prod.img) + ')' } : '']"></div>

        <div class="product__middle">
          <h2 class="product__title" v-html="prod.title"></h2>
          <p class="product__group"><span>{{texts.pGroup}}</span> {{prod.group}}</p>
          <p class="product__duration">{{prod.duration}}</p>

        </div>

      </div>
    </div>
    <div class="orders__right-block">

      <div class="inputs">
        <input class="user-data" id="name_surname" type="text" name="name_surname" v-bind:placeholder="footer.placeHolders[0]" required v-model="nameSurname"/>
        <input class="user-data" id="company" type="text" name="company" v-bind:placeholder="footer.placeHolders[1]" v-model="company"/>
        <input class="user-data" id="email" type="email" name="email" v-bind:placeholder="footer.placeHolders[2]" v-model="mail"/>

        <div class="checkboxes">
          <div class="personal">
            <input id="pi" class="personal__input" type="checkbox" v-model="personal"/>
            <label for="pi">{{footer.tickBoxes[0]}}</label>
          </div>

          <div class="commercial">
            <input id="ci" class="commercial__input" type="checkbox" v-model="commercial"/>
            <label for="ci">{{footer.tickBoxes[1]}}</label>
          </div>

          <div class="gdpr">
            <input id="gi" class="gdpr__input" type="checkbox"/>
            <label for="gi">{{footer.tickBoxes[2]}}</label>
          </div>
        </div>
      </div>

      <button name="TryButton" @click="sendOrder" class="button button--try button--rounded">{{texts.order}}</button>

    </div>


  </div>
</template>

<script>

export default {
  name: 'SingleOrder',
  data() {
    return {
      nameSurname: '',
      company: '',
      mail: '',
      personal: false,
      commercial: false,
    }
  },
  props: {
    prod: Object,
  },
  computed: {
    organizedData() {
      return {
        name: this.nameSurname,
        company: this.company,
        mail: this.mail,
        selectedProducts: this.prod,
        personal: this.personal,
        commercial: this.commercial,
      }
    },
    state() {
      return this.$root.$data.state;
    },
    texts() {
      return this.state.system.main;
    },
    footer() {
      return this.state.system.footer;
    }
  },
  methods: {
    sendOrder() {
      this.$root.$data.sendOrder({ data: this.organizedData });
    },
    cancelOrder() {
      console.log('cancel order');
      this.$root.$data.hideOrder();
    }
  }
};
</script>

<style scoped lang="stylus">

@import '~@/styles/common.styl'

.orders
  .close-cross
    position absolute
    background-image url('../assets/close-cross.png')
    right 20px
    top 20px
  h1
    font-size 28px
    font-weight 600
    color #333
    margin 60px auto
    text-align center
    +mobile()
      margin 45px auto
      padding 0 12px
    span
      font-size 24px

  .product
    min-height 0px
    width 321px
    left 0px
    right 0px
    margin auto
    &__middle
      margin-bottom 40px
  &__left-block
  &__right-block
    display inline-block
    width 49%
    vertical-align top
    +mobile()
      width 100%
    .inputs
      .user-data
        &::placeholder
          color #797979
          opacity 0.85
        +mobile()
          width 100%
      .personal,
      .commercial,
      .gdpr
        +mobile()
          width 100%
        label
          +mobile()
            width 80%
  &__right-block
    +mobile()
      padding 20px 30px 10px

  .button
    &--try
      margin-left 0px
      margin-top 25px
      font-weight 300
      +mobile()
        width 85%
        margin-bottom 60px

</style>



// WEBPACK FOOTER //
// src/components/SingleOrder.vue